export const themeConfig = {
  /**
   * If true, module colors are generated dynamically based on the tenant's brand color.
   * If false, a fixed set of "hard-coded" colors is used.
   */
  useDynamicModuleColors: false,

  /**
   * If true, dimension colors are generated dynamically based on the tenant's brand color.
   * If false, a fixed set of "hard-coded" colors is used.
   */
  useDynamicDimensionColors: false,

  /**
   * If true, the tenant's brand colors (primary, secondary, accent) are used.
   * If false, the legacy dark/neutral palette is used for the brand.
   */
  useTenantBrandColors: false,
};
